import { GlobalOutlined, LogoutOutlined, NotificationOutlined, UserOutlined } from "@ant-design/icons";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useNavigate } from "react-router-dom";
import { removeToken, removeUser, getUser, getLocale, setLocale, isUserLoggedIn } from "utils";
import { Avatar, Divider, Dropdown, Layout, notification, Space } from "antd";
import React, { useEffect, useState } from "react";
import { removeHeader } from "api/axiosService";
import ModalChangePassword from "./components/ModalChangePassword";
import localeApi from "api/locale";
import { setUiLocale } from "app/i18n";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(style);

const { Header } = Layout
export default function NavBar() {
  const navigate = useNavigate();

  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation()

  const [listLang, setListLang] = useState([{ key: process.env.REACT_APP_DEFAULT_LOCALE, label: process.env.REACT_APP_DEFAULT_LOCALE }])

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const logout = () => {
    removeToken();
    removeUser();
    removeHeader()
    navigate("/login");
  };

  const items = [
    {
      key: "2",
      label: (
        <ModalChangePassword openNotificationWithIcon={openNotificationWithIcon} />
      ),
    },
    {
      key: "3",
      label: (
        <a rel="noopener noreferrer" onClick={logout} >
          <LogoutOutlined />
          <span style={{ marginLeft: "10px" }}>{t('logout')}</span>
        </a>
      ),
    },
  ];

  const changeLocale = (value) => {
    setLocale(value.key)
    setUiLocale(value.key)
  }

  const fetchListLang = async () => {
    try {
      const res = await localeApi.getLangs()
      setListLang(res.locales)
    } catch (error) {
      console.log("🚀 ~ error:", error)
    }
  }


  useEffect(() => {
    if (!getLocale()) setLocale(process.env.REACT_APP_DEFAULT_LOCALE)
    fetchListLang()
  }, [])

  return (
    <Header className={cx('header')}>
      {contextHolder}
      <div className={cx('area-action')}>
        <Dropdown
          onChange={changeLocale}
          menu={{ items: listLang, selectable: true, defaultSelectedKeys: [getLocale()], onClick: changeLocale }}
          arrow
        >
          <GlobalOutlined style={{ fontSize: "20px", color: "#08c" }} />
        </Dropdown>
        <Divider type='vertical' />
        {
          isUserLoggedIn() &&
          <Dropdown
            menu={{ items }}
            arrow
          >
            <Space>
              <Avatar size={32} icon={<UserOutlined />} style={{ backgroundColor: '#08c' }} />
              <span>{getUser().name}</span>
            </Space>
            {/* <div>
              <UserOutlined style={{ fontSize: "20px", color: "#08c" }} />
              <span className={cx("user-name")}>{user.name}</span>
            </div> */}
          </Dropdown>
        }
      </div>
    </Header >
  );
}
